import { render, staticRenderFns } from "./taskEditor.vue?vue&type=template&id=34618904&"
import script from "./taskEditor.vue?vue&type=script&lang=js&"
export * from "./taskEditor.vue?vue&type=script&lang=js&"
import style0 from "./taskEditor.vue?vue&type=style&index=0&id=34618904&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports